
import { Container, Row, Col, Nav } from "react-bootstrap";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import webClassImg from '../assets/img/mobileDAcademy.jpg';
import masterClassImg from '../assets/img/masterClassImg.jpg';
import twdaImg from '../assets/img/twdacover.jpg';
import teachOnImg from '../assets/img/recommendedOn.png';


export const AcademyMain = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h5>Register for any of our</h5>
                <h1><span className='quoteHeader'>Best Selling Courses</span> below:</h1><br />

                <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <Nav.Link href='https://www.teacheron.com/tutor-profile/6TXt?r=6TXt' rel="noreferrer" target='_blank'><img src={teachOnImg} alt="example Img" /></Nav.Link>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                <h1>#1</h1>
                <h3>Self Pace</h3>
                <h1><span className='quoteHeader'>Mobile App</span> Development Training.</h1>
                <h4>Totlesoft App Development Academy (TADA)</h4>
                <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <Nav.Link href='/academy/app-development' rel="noreferrer" target='_blank'><img src={webClassImg} alt="example Img"/></Nav.Link>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>Do you want to learn how to Develop Mobile App without coding and get paid when other people use it? IF YES, this course is for you.</h5>

                  <h3>Special Offer Currently Open. <span className="chris">90% Off - Ending Soon!</span> Act now!</h3>
                  <Nav.Link href='/academy/app-development' rel="noreferrer" target='_blank'><h3 className="chris">LEARN MORE...</h3></Nav.Link><br /><br /><br />



                  <h1>#2</h1>
                <h3>3 MONTHS INTENSIVE COURSE</h3>
                <h1><span className='quoteHeader'>Full Stack (MERN)</span> Development Training.</h1>
                <h4>Totlesoft Web Development Academy (TWDA)</h4>
                <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <Nav.Link href='/academy/web-development' rel="noreferrer" target='_blank'><img src={twdaImg} alt="example Img"/></Nav.Link>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>This intensive practical Web Development Course is design to help you master the MERN Stack Technology in programming in the shortest possible time.</h5>

                  <h3>Special Offer Currently Open. <span className="chris">50% Off - Ending Soon!</span> Act now!</h3>
                  <Nav.Link href='/academy/web-development' rel="noreferrer" target='_blank'><h3 className="chris">LEARN MORE...</h3></Nav.Link><br /><br /><br />




                  <h1>#3</h1> 
                <h1>30 Days Master Class <span className='quoteHeader'>Graphics Design 201</span> Advance Training.</h1>
                <h4>Totlesoft Graphic Academy (TGA)</h4>
                <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <Nav.Link href='/academy/graphic-design' rel="noreferrer" target='_blank'><img src={masterClassImg} alt="example Img" /></Nav.Link>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Special Offer Currently Open also for this powerful course. <span className="chris">90% Off - Ending Soon!</span> Click link below to learn more.</h3>
                  <Nav.Link href='/academy/graphic-design' rel="noreferrer" target='_blank'><h3 className="chris">LEARN MORE...</h3></Nav.Link><br /><br />

                  <h5>Click the link below to visit Totlesoft Marketplace to see more of our products...</h5>
                  <Nav.Link href='https://selar.co/m/totlesoft' rel="noreferrer" target='_blank'><h3 className="chris">TOTLESOFT DIGITAL MARKETPLACE</h3></Nav.Link><br />
                  

                  
                 
                 </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

